export default __webpack_public_path__ + "static/container_hand-86e85dd8508533d16a6bb3aba70be6f1.png";